@import '@hevoio/hevo-ui-toolkit/styles/variables';

.card {
  display: flex;
  flex-direction: column;
  gap: $spacer-12;
  padding: $spacer-16;
  width: 100%;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: $spacer-12;
  width: 100%;
}

.identity {
  display: flex;
  flex-direction: column;
  gap: $spacer-2;
  min-width: 0;
}

// Truncate rather than wrap: a long name would otherwise push this card taller
// than its neighbours. The full value is in the tooltip.
.name {
  margin: 0;
  font-size: $font-size-body;
  font-weight: $font-weight-bold;
  color: $text-strong-950;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: $spacer-4;
  margin: 0;
  font-size: $font-size-body;
  line-height: $line-height-body;
  color: $text-sub-600;
}

.metaSeparator {
  color: $text-soft-400;
}

.headerActions {
  display: flex;
  align-items: center;
  gap: $spacer-8;
  flex-shrink: 0;
}

.inProgressChip {
  display: inline-flex;
  align-items: center;
  gap: $spacer-4;
  white-space: nowrap;
  font-size: $font-size-body;
  color: $text-sub-600;
}

.inProgressIcon {
  animation: peering-card-spin 1.2s linear infinite;
}

@keyframes peering-card-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.details {
  display: grid;
  // Two columns on a normal viewport, collapsing to one when the card is
  // narrow. `minmax(0, 1fr)` keeps a long tunnel IP from widening the column.
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: $spacer-8 $spacer-24;
  margin: 0;
  width: 100%;
}

.detail {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: $spacer-8;
  min-width: 0;
}

// Typography mirrors the job-stats rows: a muted label against a
// medium-weight value, so the value is what the eye lands on.
.detailLabel {
  font-size: $font-size-body;
  line-height: $line-height-body;
  color: $text-secondary;
  white-space: nowrap;
}

.detailValue {
  display: flex;
  align-items: center;
  gap: $spacer-4;
  margin: 0;
  min-width: 0;
  // Without this the value column refuses to shrink below its content width
  // and the ellipsis never appears.
  overflow: hidden;
  font-size: $font-size-body;
  line-height: $line-height-body;
  font-weight: $font-weight-medium;
  color: $text-strong-950;
}

// A peering can carry many CIDRs, so the value is capped to one line and the
// tooltip holds the rest. The copy button still copies the whole string.
.detailCopy {
  flex-shrink: 0;
}

.detailText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
